<template>
  <div class="availability-wrapper">
    <!-- Main bar -->
<!-- Main bar -->

          <div class="availability-bar mt-2">
            <!-- Non-operating / weekend shade -->
            <div v-if="isWeekend && shadeWeekends" class="shade weekend-shade"></div>
            <div v-if="hasOperatingHours" class="shade non-operating-left"></div>
            <div v-if="hasOperatingHours" class="shade non-operating-right"></div>

            <!-- Trip segments -->
            <div
              v-for="trip in computedSegments"
              :key="trip.Id"
              class="segment"
              :style="{ left: trip.startPercent + '%', width: trip.widthPercent + '%' }"
              :class="{ violation: trip.violation }"
            ></div>

            <!-- Hour ticks -->
            <template v-if="showTicks">
              <div v-for="hour in tickHours" :key="hour" class="tick" :style="{ left: (hour / 24 * 100) + '%' }">
                <div class="tick-line"></div>
              </div>
            </template>
          </div>

          <!-- Hour labels below -->
          <template v-if="showTicks">
            <div class="tick-labels">
              <span v-for="hour in tickHours" :key="'label-' + hour" :style="{ left: (hour / 24 * 100) + '%' }">
                {{ String(hour).padStart(2, '0') }}:00
              </span>
            </div>
          </template>

  </div>

</template>

<script>
export default {
  name: 'VehicleAvailabilityBar',
  props: {
    trips: { type: Array, default: () => [] },
    day: { type: Date, default: () => new Date() },
    showTicks: { type: Boolean, default: true },
    operatingHours: { type: Object, default: null }, // e.g., { start: 7, end: 19 }
    shadeWeekends: { type: Boolean, default: false }
  },
  computed: {
    isWeekend () {
      const d = this.day.getDay() // 0=Sun, 6=Sat
      return d === 0 || d === 6
    },
    hasOperatingHours () {
      return this.operatingHours && !this.isWeekend
    },
    tickHours () {
      return [0, 4, 8, 12, 16, 20] // Customize as needed
    },
    computedSegments () {
      const dayStart = new Date(this.day)
      dayStart.setHours(0, 0, 0, 0)
      const dayStartMs = dayStart.getTime()

      var tripComp = this.trips.map((trip, index) => {
        // const start = new Date(trip.StartTime)
        // const end = new Date(trip.EndTime)

        const start = new Date(trip.StartTime.split('.')[0])
        const end = new Date(trip.EndTime.split('.')[0])

        const startMinutes = (start.getTime() - dayStartMs) / 60000
        const endMinutes = (end.getTime() - dayStartMs) / 60000

        const safeStart = Math.max(0, startMinutes)
        const safeEnd = Math.min(1440, endMinutes)

        // console.log(`id:${index}`)

        return {
          id: trip.Id, //index,
          id2: index,
          startPercent: (safeStart / 1440) * 100,
          widthPercent: ((safeEnd - safeStart) / 1440) * 100,
          violation: trip.ViolationAllCount > 0
        }
      })

      // console.log("Trips for Day:")
      // console.log(tripComp)
      return tripComp
    }
  }
}
</script>

<style scoped>
.availability-wrapper {
  width: 100%;
}
/* .availability-bar {
  position: relative;
  height: 28px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
} */

.availability-bar {
  position: relative;
  height: 24px; /* Adjust height as needed */
  background: #e0e0e0; /* Idle/available color */
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
}

.shade {
  position: absolute;
  top: 0;
  height: 100%;
  opacity: 0.3;
}
.weekend-shade {
  left: 0;
  width: 100%;
  background: #9e9e9e;
}
.non-operating-left {
  left: 0;
  width: calc((v-bind('operatingHours.start') / 24) * 100%);
  background: #bdbdbd;
}
.non-operating-right {
  left: calc((v-bind('operatingHours.end') / 24) * 100%);
  width: calc(((24 - v-bind('operatingHours.end')) / 24) * 100%);
  background: #bdbdbd;
}
.segment {
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(76, 175, 80, 0.8); /* Default green for no violations */
  border-radius: 2px;
}

.segment.violation {
  background: rgba(244, 67, 54, 0.9); /* Red for violations */
}

.tick {
  position: absolute;
  top: 0;
  width: 1px;
  height: 100%;
  transform: translateX(-50%);
}
.tick-line {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}
.tick-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 11px;
  color: #666;
  position: relative;
}
.tick-labels span {
  position: absolute;
  transform: translateX(-50%);
}
</style>
